import validUrl from "valid-url";
import { nanoid } from "nanoid";
import firestore from "../firebase/firestore";

export const getUrlShortner = (urlCode) => {
  if (!urlCode || urlCode === "") return false;
  try {
    const ref = firestore.collection("url_shortner");
    return ref.doc(urlCode).get();
  } catch (err) {
    console.error("Erro ao adicionar a tabulação", err);
    return err;
  }
};

export const createUrlShortner = (type, urlCode, longUrl, baseUrl) => {
  if (!urlCode || urlCode === "") return { error: "invalidURLCode" };
  if (!validUrl.isUri(longUrl)) {
    console.error("Não é uma url longa valida");
    return { error: "invalidURL" };
  }
  const ref = firestore.collection("url_shortner");
  try {
    let data = {
      urlCode,
      longUrl,
      updated_at: new Date(),
      shortUrl: baseUrl + urlCode,
    };
    if (type === "new")
      (data.created_at = new Date()), console.log("data: ", data);
    return ref.doc(urlCode).set(data, { merge: true });
  } catch (err) {
    console.error("Erro ao criar Url Curta", err);
    return { errror: err };
  }
};

export const createUrlCode = () => {
  try {
    let code = nanoid(7);
    return code;
  } catch (err) {
    console.error("Erro ao criar o código de acesso", err);
  }
};
